export class FileDetails {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.name = obj.name || '';
        this.fileNumber = obj.fileNumber || '';
        this.type = obj.type || '';
        this.description = obj.description || '';
        this.updateTimeUtc = obj.updateTimeUtc || '';
        this.hash = obj.hash || '';
        this.docTypeCode = obj.docTypeCode || '';
    }
}

export class File {
    constructor(obj = {}) {
        // eslint-disable-next-line symbol-description
        this._id = Symbol();
        this.uid = '' || obj.uid;
        this.id = obj.id || 0;
        this.fileName = obj.fileName || '';
        this.content = obj.content || '';
        this.typeId = obj.typeId || '';
        this.fileDescription = obj.fileDescription || '';
        this.description = obj.description || '';
        this.registerEntityFieldValueId = obj.registerEntityFieldValueId || '';
        this.tempId = obj.tempId || '';
        this.hash = obj.hash || '';
        this.docTypeCode = obj.docTypeCode || '';
    }
}

export class BudgetReportFileModel {
    constructor(obj = {}) {
        this.id = obj.id || '';
        this.fileName = obj.fileName || '';
        this.content = obj.content || '';
        this.budgetReportItemId = obj.budgetReportItemId || '';
        this.hash = obj.hash || '';
        this.docTypeCode = obj.docTypeCode || '';
        this.reportingDocId = obj.reportingDocId;
        this.orgDocId = obj.orgDocId;
    }
}
